export default __webpack_public_path__ + "static/media/pBNB.ae51f492.svg";